import React from "react"

// UnderstandingFinanceImage
//
// Return a UF image file from the static files.
const startUfID = 1
const endUfID = 8
let currentUfID = 0

const UnderstandingFinanceImage = () => {

  // Cycle through the image options options.
  if(currentUfID === 0) {
    currentUfID = Math.floor((Math.random() * endUfID) + 1)
  }
  else {
    currentUfID ++
    if(currentUfID > endUfID) currentUfID = startUfID
  }

  let imgFile = (<img className={"uf-image uf-image--version"+currentUfID} src={"/svg/understanding-finance/Understanding-Finance-Icons-"+currentUfID+".svg"} alt="Understanding Finance" />)
  return (imgFile)
}

export default UnderstandingFinanceImage

